import React from 'react';
import { NavLink } from 'react-router-dom';
import HomeIcon from '../../assets/img/custom/home.svg';
import MailIcon from '../../assets/img/custom/mail.svg';
import PaletteIcon from '../../assets/img/custom/palette.svg';
import NotepadIcon from '../../assets/img/custom/notepad.svg';
import TransactionIcon from '../../assets/img/custom/transaction.svg';

const DesignerMenu = ({ locationPath }) => (
  <>
    <li
      className={`menu-item ${
        locationPath === '' || locationPath === undefined ? 'active' : ''
      } d-flex justify-content-center`}
    >
      <NavLink end to="/" className="menu-link">
        <div>
          <img alt="dashboard" src={HomeIcon} />
          <span className="menu-label">Dashboard</span>
        </div>
      </NavLink>
    </li>
    <li
      className={`menu-item ${
        locationPath === 'project' ? 'active' : ''
      } d-flex justify-content-center`}
    >
      <NavLink to="/project" className="menu-link">
        <div>
          <img alt="project" src={MailIcon} />
          <span className="menu-label">Project</span>
        </div>
      </NavLink>
    </li>
    <li
      className={`menu-item ${
        locationPath === 'portfolio' ? 'active' : ''
      } d-flex justify-content-center`}
    >
      <NavLink to="/portfolio" className="menu-link">
        <div>
          <img alt="portfolio" src={PaletteIcon} />
          <span className="menu-label">Portofolio</span>
        </div>
      </NavLink>
    </li>
    <li
      className={`menu-item ${
        locationPath === 'project-review' ? 'active' : ''
      } d-flex justify-content-center`}
    >
      <NavLink to="/project-review" className="menu-link">
        <div>
          <img alt="project review" src={NotepadIcon} />
          <span className="menu-label">Project Review</span>
        </div>
      </NavLink>
    </li>
    <li
      className={`menu-item ${
        locationPath === 'transactions' ||
        locationPath === 'requestdisbursement'
          ? 'active'
          : ''
      } d-flex justify-content-center`}
    >
      <NavLink to="/transactions" className="menu-link">
        <div>
          <img alt="transaction" src={TransactionIcon} />
          <span className="menu-label">Transactions</span>
        </div>
      </NavLink>
    </li>
  </>
);

export default DesignerMenu;
